React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_list_header_component')

module.exports = class ListHeaderComponent extends React.Component
  render: t.renderable ->
    t.div '.title', =>
      t.h2 =>
        t.text @props.title
      if @props.allCount > 0
        t.div '.subtitle', =>
          if !@props.isFiltering
            t.format 'total-count', count: @props.allCount
          else
            t.format 'showing-x-of-y', count: @props.count, total: @props.allCount

          if @props.isSortable
            t.a onClick: (e) =>
              e.stopPropagation()
              e.preventDefault()
              @props.onSortClick(e.currentTarget)
            , =>
              t.span '.dash-sorting', =>
                t.format [@props.sortField, @props.sortOrder]
                t.icon 'dropdown-menu'

          if @props.isFiltering
            t.a '.show-all.clickable', onClick: @props.onShowAll, ->
              t.format 'show-all'

      if @props.isOnPublicBoards
        t.div '.public-board-view-hint', ->
          t.format 'public-board-page-description'
          t.a {
            class: 'public-boards-link'
            href: 'https://help.trello.com/article/1127-managing-public-boards-within-an-enterprise'
            target: '_blank'
          }, ->
            t.format 'learn-more'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/list-header-component.coffee